import { render, staticRenderFns } from "./ParamsTypeMaterial.vue?vue&type=template&id=61d49697&scoped=true"
import script from "./ParamsTypeMaterial.vue?vue&type=script&lang=js"
export * from "./ParamsTypeMaterial.vue?vue&type=script&lang=js"
import style0 from "./ParamsTypeMaterial.vue?vue&type=style&index=0&id=61d49697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d49697",
  null
  
)

export default component.exports